<div *ngIf="InProgress">
  <div class="spinner_design" id="spinner_close">
    <mat-spinner></mat-spinner>
    <p>We are in the process of setting up your account. Please wait a few seconds.</p>
  </div>
</div>

<div class="authentification page_login " *ngIf="!InProgress">
  <div class="wrapper row d-lg-flex align-items-center">
    <div class="col-lg-6" style="padding: 48px 156px 20px 156px; background-color: #fff !important;">
      <div class="w-desktop">
        <p *ngIf="previousUrl != undefined">Previous URL: {{ previousUrl | async }}</p>
        <div class="row head" style="margin-bottom: 80px ;">
          <a href="/"><img src="../../../assets/images/conversell-logo.png" alt="Conversell"></a>
        </div>
        <div class=" pr-2 mx-auto mt-3">
          <h1>Log in</h1>
          <span class="descTitle"> Welcome back! Please enter your details. </span>
          <form novalidate [formGroup]="loginForm" class="card_design" (ngSubmit)="submitted = true">
            <div class="form-group">
              <label class="Label__Text">Email</label><br>
              <div subscriptSizing="dynamic">
                <input pInputText placeholder="" formControlName="email" required placeholder="Enter your email">
              </div>
              <mat-error
                *ngIf="loginForm.controls['email'].touched  && loginForm.controls['email'].hasError('required') ">
                An email address is required.
              </mat-error>
              <mat-error *ngIf="loginForm.controls['email'].touched && loginForm.controls['email'].hasError('email') ">
                Enter a valid email address.
              </mat-error>
            </div>
            <label class="Label__Text">Password</label>
            <div class="form-group">
              <div floatLabel="auto" subscriptSizing="dynamic" class="inputpassword">
                <input pInputText matInput [type]="hide ? 'password' : 'text'" placeholder="*********"
                  formControlName="password" required autocomplete>
                <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hide">
                  <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
              </div>
              <mat-error
                *ngIf="loginForm.controls['password'].touched && loginForm.controls['password'].hasError('required')">
                Password is required.
              </mat-error>
            </div>
            <div class="LinkPassword">
              <mat-checkbox class="example-margin padd0">
                Remember for 30 days
              </mat-checkbox>
              <a class="forget_pasword" routerLink="/auth/forget-password">Forgot password?</a>
            </div>
            <div class="form-group">
              <div class="btn-1">
                <button (click)="login()" class="d-block w-100" [disabled]="loginForm.invalid">Sign In</button>
              </div>
            </div>
            <div class="row mt-3 mb-3">
              <div class="col-md-5 col-5">
                <div class="divider"></div>
              </div>
              <div class="col-md-2 col-2 p-0">
                <h2 class="line_devider text-center">
                  OR
                </h2>
              </div>
              <div class="col-md-5 col-5">
                <div class="divider"></div>
              </div>
            </div>
            <div class="btn-defaut btn-login">
              <button type="button" id="gmail" (click)="signInWithGoogle()" class="margBott12 d-block w-100">Sign in
                with
                Google</button>
              <button type="button" id="facebook" class="d-block w-100 margBott12" (click)="signInWithFB()">Sign in with
                Facebook</button>
              <div id="buttonDiv"></div>
              <button type="button" id="amazon" class="d-block w-100" (click)="signInWithAmazon()">Sign in with
                amazon</button>
            </div>
            <div class="loginDescription">
              <p><span class="sign-up">Don't have an account? </span><a routerLink="/auth/signup">Sign up</a></p>
            </div>
          </form>
        </div>
        <div class="row">
          <div class="text_term-privacy">
            <p style="margin-bottom: 0!important;">
              By clicking “Submit”, you acknowledge that you have read and understood,
              and agree to Conversell's <a href="https://www.conversell.ai/terms-of-use.html" target="_blank"> "Terms of
                use" </a> and <a target="_blank" href="https://www.conversell.ai/privacy-policy-solution.html"> "Privacy
                Policy" </a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 text-lg-end">
      <img src="../../../../../assets/images/screen_mockup.png" alt="">
    </div>
  </div>